import React, { useEffect } from 'react'
import { sendWebViewMsg } from 'utils/bridge'
import { useHistory } from 'react-router-dom'

export default function UrlChangeNativeHandler() {
  const history = useHistory()

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    history.listen(async (location, action) => {
      sendHistoryChangeSignal(location, action)
    })
  }, [])
  const sendHistoryChangeSignal = async (location, action) => {
    if (window?.ReactNativeWebView?.postMessage) {
      let response = await sendWebViewMsg({
        action: 'RES_URL_HISTORY_CHANGE',
        data: {
          action: action,
          location: location,
        },
      }).catch((err) => {
        console.log('err from msg')
        console.log(err)
      })
    }
  }

  return null
}
